import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../../components/UI/Layout/Layout';
import WireInfoComponent from '../../../components/WireDataComponents/WireInfoComponent/WireInfoComponent';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class WireInfoPage extends Component {
  goBackHandler = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;
    return (
      <Layout
        title={LocalizedStrings[language].wireData}
        clicked={this.goBackHandler}
        country={country}
        language={language}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
      >
        <WireInfoComponent country={country} language={language} />
      </Layout>
    );
  }
}

WireInfoPage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(WireInfoPage);
